import React, { Component, Fragment } from "react";
import { StepCard, TitleStep, TableKpi } from "./../../../StyledComponents";
import { Tooltip, Icon, Checkbox } from "antd";

import StatementLabelContainer from "./../SurveyStepActionsKpiTabElements/StatementLabelContainer";
import KpiCheckbox from "./../SurveyStepActionsKpiTabElements/KpiCheckboxContainer";
import MediaInput from "./../SurveyStepActionsKpiTabElements/MediaInputContainer";
import DisplaySwitch from "./../SurveyStepActionsKpiTabElements/DisplaySwitchContainer";
import ComLocation from "../SurveyStepActionsKpiTabElements/ComLocation";
import _ from "lodash";
import ModalComponent from "../../../../modalComponent/ModalComponent";

let statements = [];
const ActionTypesLink = props => {
  return (
    <a className="ant-dropdown-link" onClick={props.onClick}>
      {`${props.statement.actions.length} type${props.statement.actions.length > 1 ? "s" : ""} d'action`}
    </a>
  );
};

const ActionTypesModal = props => {
  if (!props.statement) {
    return null;
  }
  const statement = props.statement || {};
  const actions = statement.actions || [];
  const actionTypes = props.actionTypes || [];
  const statementActionTypes = actionTypes.find(v => v.id === statement.id);
  if (!statementActionTypes) return null;
  const statementActionTypesActions = [...statementActionTypes.actions] || [];
  return (
    <ModalComponent title={`Sélection des types d'action`} showModal={props.showModal} closeModal={props.closeModal}>
      {statementActionTypesActions.map((item, index) => {
        return (
          <div key={index} style={{ margin: "6px 0" }}>
            <Checkbox
              value={item.id}
              onChange={({ target = {} }) => {
                if (actions.length === 1 && !target.checked) {
                  return;
                }
                props.updateStatementActions(statement, item, target.checked);
              }}
              checked={actions.find(v => v.id === item.id)}
            >
              {item.label}
            </Checkbox>
          </div>
        );
      })}
    </ModalComponent>
  );
};

class SurveyStepActionsKpiTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      currentStatement: null
    };

    const actionsList = this.props.actionsList || [];
    statements = [];

    for (let i = 0; i < actionsList.length; i++) {
      const actionsListElement = actionsList[i];
      let statement = { ...actionsListElement };
      //mapping TODO refactor
      statement.title = statement.label || "";
      statement.label = statement.question || "";
      statement.statementId = statement.id + "" || "";
      statement.displayType = statement.type || "";
      //statement.conditionStatus = statement.condition || false;
      //statement.condition || false;
      statement.conditions = [];
      statement.conditionStatus = !statement.condition;
      statement.medias = [];
      statement.mediaQuantity = [
        {
          type: "Photo",
          quantity: "0"
        },
        {
          type: "Video",
          quantity: "0"
        },
        {
          type: "Audio",
          quantity: "0"
        }
      ];

      statements.push(statement);
    }
  }

  getKpiGroupName(kpi = {}) {
    const displayGroup = kpi.display_group || [];
    if (displayGroup.length === 0) {
      return "";
    } else {
      return displayGroup[0];
    }
  }

  render() {
    const { locationType, updateStatementActions, currentStatements } = this.props;
    let currentStatement = null;

    if (this.state.currentStatement) {
      currentStatement = currentStatements.find(v => v.id === this.state.currentStatement.id);
    }

    let kpisList = [...this.props.kpisList];
    //_.remove(kpisList, { source: "PDC" });
    //hide com kpis
    kpisList = kpisList.filter(v => {
      return v.id !== 37 && v.id !== 115;
    });
    kpisList = _.orderBy(kpisList, ["priority", "id"], ["asc", "asc"]);

    /*kpisList.sort(function(k1, k2) {
			const k1Id = k1.id || 0;
			const k2Id = k2.id || 0;
			return k1Id - k2Id;
		});*/
    let kpiGroupNameIndex = 0;
    let previousKpiGroupName = "";
    return (
      <Fragment>
        <div>
          <div className="p-mrg-ver p-clr-mdg">
            <div>
              <ComLocation location={this.props.location} />
            </div>
          </div>
          <div className="p-survey-4-scroll p-mrg-top-l">
            <div className="p-flex p-w-100">
              <div className="p-survey-4-cols" />
              {statements.map((statement, index) => {
                return (
                  <div key={index} className="p-survey-4-cols p-mrg-bot p-txt-center">
                    <b>{statement.title}</b>
                    {/*<ActionTypesLink
															statement={
																currentStatements.find(
																	v => v.id === statement.id
																) || statement
															}
															onClick={() => {
																this.setState({
																	currentStatement: statement,
																	isModalOpen: !this.state.isModalOpen,
																});
															}}
														/>*/}
                  </div>
                );
              })}
            </div>
            <div className="p-flex p-w-100">
              <div className="p-survey-4-cols p-survey-4-cols-kpi" style={{ visibility: "hidden" }}>
                Question
              </div>
              <div className="p-survey-4-cols" />
              {statements.map((statement, index) => {
                return (
                  <div className="p-survey-4-cols p-mrg-bot-s">
                    <StatementLabelContainer locationType={locationType} statement={statement} />
                  </div>
                );
              })}
            </div>
            <div className="p-flex">
              <div className="p-survey-4-cols p-survey-4-cols-kpi" style={{ borderTop: "1px solid #f0f0f0" }}>
                Matrice
              </div>
              <div className="p-survey-4-cols" />
              {statements.map((statement, index) => {
                return (
                  <div className="p-survey-4-cols p-al-r-full-center p-survey-4-rows">
                    <Tooltip placement="left" title={statement.label}>
                      <DisplaySwitch locationType={locationType} statement={statement} />
                    </Tooltip>
                  </div>
                );
              })}
            </div>

            <div>
              {kpisList.map((kpi, index) => {
                if (!kpi.survey_display) return null;
                const kpiGroupName = this.getKpiGroupName(kpi);

                if (previousKpiGroupName !== kpiGroupName && kpiGroupName) {
                  kpiGroupNameIndex++;
                  previousKpiGroupName = kpiGroupName;
                }

                let kpiClassName = kpiGroupNameIndex % 2 ? "" : "group-2";

                return kpi.survey_display ? (
                  <div className="p-flex p-w-100">
                    <div className="p-survey-4-cols p-survey-4-cols-kpi">
                      <div className={`p-survey-4-cols-kpi-group ${kpiClassName}`}>{kpiGroupName}</div>
                      <div>{kpi.long_label}</div>
                    </div>
                    <div className="p-survey-4-cols" />
                    {statements.map((statement, index) => {
                      return (
                        <div
                          className="p-survey-4-cols p-al-r-full-center p-survey-4-rows"
                          style={index % 2 === 0 ? null : { backgroundColor: "#f9f9f9" }}
                        >
                          <Tooltip placement="left" title={statement.label}>
                            <KpiCheckbox locationType={locationType} statement={statement} kpi={kpi} />
                          </Tooltip>
                        </div>
                      );
                    })}
                  </div>
                ) : null;
              })}
            </div>

            <div className="p-flex p-w-100">
              <div className="p-survey-4-cols p-survey-4-cols-kpi">Photos</div>
              <div className="p-survey-4-cols" />
              {statements.map((statement, index) => {
                let type = "Photo";
                return (
                  <div className="p-survey-4-cols p-al-r-full-center p-survey-4-rows">
                    <Tooltip placement="left" title={statement.label}>
                      <MediaInput locationType={locationType} statement={statement} type={type} />
                    </Tooltip>
                  </div>
                );
              })}
            </div>

            <div className="p-flex p-w-100">
              <div className="p-survey-4-cols" />
              {statements.map((statement, index) => {
                return (
                  <div className="p-survey-4-cols p-mrg-bot p-mrg-top p-txt-center">
                    <b>{statement.title}</b>
                  </div>
                );
              })}
            </div>

            {/*
									<tr style={{ height: "50px" }}>
										<th className="row">Vidéo</th>
										{statements.map((statement, index) => {
											let type = "Video";
											return (
												<th>
													<Tooltip placement="left" title={statement.label}>
														<MediaInput
															locationType={locationType}
															statement={statement}
															type={type}
														/>
													</Tooltip>
												</th>
											);
										})}
									</tr>
									<tr style={{ height: "50px" }}>
										<th className="row">Audio</th>
										{statements.map((statement, index) => {
											let type = "Audio";
											return (
												<th>
													<Tooltip placement="left" title={statement.label}>
														<MediaInput
															locationType={locationType}
															statement={statement}
															type={type}
														/>
													</Tooltip>
												</th>
											);
										})}
									</tr>
									*/}
          </div>
        </div>
        <ActionTypesModal
          actionTypes={this.props.actionTypes}
          statement={currentStatement || this.state.currentStatement}
          showModal={this.state.isModalOpen}
          closeModal={() => {
            this.setState({
              isModalOpen: false
            });
          }}
          updateStatementActions={(statement, action, checked) => {
            updateStatementActions(locationType, statement, action, checked);
          }}
        />
      </Fragment>
    );
  }
}

export default SurveyStepActionsKpiTab;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/SurveyStepActionsKpiTab/SurveyStepActionsKpiTab.js